export enum EmploymentProofType {
  WageSlip = 'WageSlip',
  EmploymentCertification = 'EmploymentCertification',
}

export enum CertificateType {
  EmploymentCertification = 0,
  WageSlip = 1,
}

export enum CompletionType {
  Employment = 1,
  Document = 2,
  Contact = 3,
}

export enum SigningType {
  BankId = 1,
  Scrive = 2,
  Post = 3,
}

export enum TypeOfFile {
  WageSlip = 'WageSlip',
  EmploymentCertificate = 'EmploymentCertificate',
  OtherCertificate = 'OtherCertificate',
  TemplateFile = 'TemplateFile',
  NonQualifyingPeriodAttachment = 'NonQualifyingPeriodAttachment',
  SignedDocument = 'SignedDocument',
  CV = 'CV',
}

export enum SigningTypeChoice {
  BankId = 'BankId',
  NoBankId = 'NoBankId',
}

export enum TimeWorkedRowStatus {
  Valid = 'Valid',
  Invalid = 'Invalid',
  Incomplete = 'Incomplete',
  Empty = 'Empty',
}

export enum InputMode {
  Numeric = 'numeric',
  Telephone = 'tel',
  Text = 'text',
}

export enum NewContractApplicationType {
  CompetenceSupportPermanentEmployed = 'competenceSupportPermanentEmployed',
  CompetenceSupport = 'competenceSupport',
  Illness = 'illness',
  TemporaryEmployment = 'temporaryEmployment',
  PermanentEmployment = 'permanentEmployed',
}

export enum ReduxSliceType {
  Completion = 'completion',
  NewContract = 'newContract',
}

export enum ApplicationAddressType {
  SwedishAddress = 'swedishAddress',
  ForeignAddress = 'foreignAddress',
}

export enum ResponseStatus {
  Complete = 'complete',
  Failed = 'failed',
}

export enum AdjustmentAidApplicationType {
  Dismissed = 1,
  Bankruptcy = 2,
  Illness = 3,
}

export enum AdjustmentAidMyRoleType {
  UnionRep = 'unionRep',
  CompanyRep = 'companyRep',
}

export enum AdjustmentAidUnionRoleType {
  UnionDelegate = 'unionDelegate',
  UnionElected = 'unionElected',
}

export enum MoreApplications {
  MoreApplications = 'yes',
  NoMoreApplications = 'no',
}
